// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#candidateRow td {
    color: black;
}
.table th{
    cursor: pointer;
    white-space: nowrap;
}
.table td,.table span{
    /* white-space: nowrap; */
}
.flex-container {
    display: flex;
    flex-direction: column;
}
.filter-td {
    vertical-align: top;
    padding-right: 50px;
}
.filter-title {
    /* color: #000000; */
    font-size: 50;
    font-weight: bold;
}
.experience-input {
    width: 50px;
}`, "",{"version":3,"sources":["webpack://./src/app/shortlisted/shortlisted.component.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;AACA;IACI,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,oBAAoB;IACpB,aAAa;IACb,iBAAiB;AACrB;AACA;IACI,WAAW;AACf","sourcesContent":["#candidateRow td {\n    color: black;\n}\n.table th{\n    cursor: pointer;\n    white-space: nowrap;\n}\n.table td,.table span{\n    /* white-space: nowrap; */\n}\n.flex-container {\n    display: flex;\n    flex-direction: column;\n}\n.filter-td {\n    vertical-align: top;\n    padding-right: 50px;\n}\n.filter-title {\n    /* color: #000000; */\n    font-size: 50;\n    font-weight: bold;\n}\n.experience-input {\n    width: 50px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
